// extracted by css-extract-rspack-plugin
export default {"cls1":"LandingScreen-cls1_4ti","cls2":"LandingScreen-cls2_nRC LandingScreen-cls1_4ti"};